function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import file from '@/utils/file';
Vue.use(file);
import { folderForceDeleteApi, folderForceDeletesApi, folderSpaceEntRecoverApi, folderSpaceEntRecycleApi, folderSpaceEntAllRecoverApi } from '@/api/cloud';
import defaultPage from '@/components/common/defaultPage';
import oaFromBox from '@/components/common/oaFromBox';
export default {
  name: 'RecoveryFile',
  components: {
    defaultPage: defaultPage,
    oaFromBox: oaFromBox
  },
  props: {},
  data: function data() {
    return {
      fileData: [],
      where: {
        page: 1,
        limit: 15
      },
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      dropdownList: [{
        label: '恢复文件',
        value: '1'
      }],
      search: [{
        field_name: '搜索文件名称',
        field_name_en: 'keyword',
        form_value: 'input'
      }, {
        field_name: '删除时间',
        field_name_en: 'time',
        form_value: 'date_picker'
      }],
      loading: false,
      total: 0,
      ids: []
    };
  },
  mounted: function mounted() {
    this.getTreeData();
  },
  methods: {
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTreeData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTreeData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this = this;
      this.ids = [];
      val.map(function (item) {
        _this.ids.push(item.id);
      });
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where = {
          limit: this.where.limit
        };
      } else {
        this.where = _objectSpread(_objectSpread({}, this.where), data);
      }
      this.where.page = 1;
      this.getTreeData();
    },
    dropdownFn: function dropdownFn() {
      var _this2 = this;
      if (this.ids.length == 0) {
        this.$message.error('至少选中一个数据');
        return false;
      }
      var data = {
        id: this.ids
      };
      this.$modalSure('确定批量恢复选中数据').then(function () {
        folderSpaceEntAllRecoverApi(data).then(function (res) {
          if (res.status == 200) {
            _this2.getTreeData();
          }
        });
      });
    },
    getTreeData: function getTreeData() {
      var _this3 = this;
      this.loading = true;
      folderSpaceEntRecycleApi(this.where).then(function (res) {
        _this3.loading = false;
        _this3.fileData = res.data.list;
        _this3.total = res.data.count;
      });
    },
    // 删除文件
    deleteFn: function deleteFn(id) {
      var _this4 = this;
      this.$modalSure('确定彻底删除此数据').then(function () {
        folderForceDeleteApi(id).then(function (res) {
          if (res.status == 200) {
            var totalPage = Math.ceil((_this4.total - 1) / _this4.where.limit);
            var currentPage = _this4.where.page > totalPage ? totalPage : _this4.where.page;
            _this4.where.page = currentPage < 1 ? 1 : currentPage;
            _this4.getTreeData();
          }
        });
      });
    },
    backFn: function backFn() {
      this.$emit('backFn');
    },
    // 批量删除
    batchDeletFn: function batchDeletFn() {
      var _this5 = this;
      if (this.ids.length == 0) {
        this.$message.error('至少选中一个数据');
        return false;
      }
      var data = {
        id: this.ids
      };
      this.$modalSure('确定批量删除选中数据').then(function () {
        folderForceDeletesApi(data).then(function (res) {
          if (res.status == 200) {
            var totalPage = Math.ceil((_this5.total - _this5.ids.length) / _this5.where.limit);
            var currentPage = _this5.where.page > totalPage ? totalPage : _this5.where.page;
            _this5.where.page = currentPage < 1 ? 1 : currentPage;
            _this5.getTreeData();
          }
        });
      });
    },
    recoveryFn: function recoveryFn(id) {
      var _this6 = this;
      this.$modalSure('确定恢复此数据').then(function () {
        folderSpaceEntRecoverApi(id).then(function (res) {
          if (res.status == 200) {
            _this6.getTreeData();
          }
        });
      });
    }
  }
};